module.exports = "https://r.nearpod.com/assets/media/image/matching-pairs-843c717cc430236dae217d09ad5be5ad.svg";